import { QuestionRadioButtonsField, QuestionYesNoField } from 'components/Questionnaires/fields';
import { requiredValidator } from 'components/Questionnaires/validators';
import { getKey, DocumentKeys } from 'common/forms/documentTypes';
import { uploadSupportingDocField } from 'common/questionnaires/definitions/fields';

export function nonqualifiedIntermediaryBlock({ visible }) {
  return {
    id: 'nonqualifiedIntermediary',
    title: 'questionnaire.ch3.nonqualifiedIntermediary',
    component: undefined,
    info: {
      instructions: 'questionnaire.ch3.nonqualifiedIntermediary.info',
    },
    visible,
    questions: [
      {
        id: 'certification',
        component: QuestionRadioButtonsField,
        componentProps: {
          items: 'questionnaire.ch3.nonqualifiedIntermediary.certification.items',
          inputName: 'nonqualifiedIntermediary'
        },
        visible: true,
        label: 'questionnaire.ch3.nonqualifiedIntermediary.certification.label',
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.ch3.nonqualifiedIntermediary.certification.errorMessage' }
          ]
        }
      },
      {
        id: 'isAltStatement',
        component: QuestionYesNoField,
        visible: true,
        label: 'questionnaire.ch3.nonqualifiedIntermediary.isAltStatement.label',
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.ch3.nonqualifiedIntermediary.isAltStatement.errorMessage' }
          ]
        }
      },
      uploadSupportingDocField({
        id: 'simpleWithholdingStatement',
        docType: getKey(DocumentKeys.SIMPLE_WHD_STATEMENT),
        visible: bAnswers => bAnswers?.isAltStatement === 'No'
          && bAnswers?.certification === '1',
        hasFootnote: true
      }),
      uploadSupportingDocField({
        id: 'pooledWithholdingStatement',
        docType: getKey(DocumentKeys.POOLED_WHD_STATEMENT),
        visible: bAnswers => bAnswers?.isAltStatement === 'No'
          && bAnswers?.certification === '2',
        hasFootnote: true
      }),
      uploadSupportingDocField({
        id: 'altWithholdingStatement',
        docType: getKey(DocumentKeys.ALT_WHD_STATEMENT),
        visible: bAnswers => bAnswers?.isAltStatement === 'Yes',
        hasFootnote: true
      }),
      {
        id: 'isQsl',
        component: QuestionYesNoField,
        visible: true,
        label: 'questionnaire.ch3.nonqualifiedIntermediary.isQsl.label',
        validation: {
          conditions: [
            { condition: requiredValidator, message: 'questionnaire.ch3.nonqualifiedIntermediary.isQsl.errorMessage' }
          ]
        }
      },
      uploadSupportingDocField({
        id: 'qslStatement',
        docType: getKey(DocumentKeys.QSL_STATEMENT),
        visible: bAnswers => bAnswers?.isQsl === 'Yes'
      })
    ]
  };
}

export default nonqualifiedIntermediaryBlock;
